export enum TemplateInputType {
    DATE_RANGE = 'DATE_RANGE',
    STRING = 'STRING',
}
